import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

const styles = () => ({
	submitButton : {
		marginTop : 30,
		fontSize : 18,
		borderRadius : '100px',
		padding : '20px 60px',
		textTransform: 'uppercase'
	},
});

class FormNewSubmitButton extends PureComponent {
	render () {
		const {isDisabled } = this.props;
		return (
			<>
				{!isDisabled && this.renderActive()}
				{isDisabled && this.renderDisabled()}
			</>
		);
	}

	renderActive() {
		const { classes, onClick, buttonText} = this.props;
		return (
			<Button onClick={onClick} variant="contained" color="primary" className={classes.submitButton}>
				{buttonText}
			</Button>
		);
	}

	renderDisabled() {
		const { classes, buttonText, disabledText = 'Write access is disabled'} = this.props;
		return (
			<Tooltip
				title={disabledText}
				enterDelay={300}
			>
				<div style={{display:'inline-block'}}>
					<Button variant="contained" color="primary" className={classes.submitButton} disabled>
						{buttonText}
					</Button>
				</div>
			</Tooltip>
		);
	}
}

FormNewSubmitButton.propTypes = {
	onClick : PropTypes.func.isRequired,
	buttonText : PropTypes.string.isRequired,
	classes: PropTypes.object.isRequired,
	isDisabled : PropTypes.bool,
	disabledText : PropTypes.string,
};

export default _.flow([
	withStyles(styles),
])(FormNewSubmitButton);
